<section>
  <div class="main-container">
    <div class="main">
      <div class="close" [mat-dialog-close]>
        <img src="../../assets/close-icon.svg" alt="">
      </div>
      <div class="header">Log a New Claim</div>


        <form
          [formGroup]="claimsForm"
        >
          <mat-form-field appearance="outline">
            <mat-label>Incident Location</mat-label>
            <input type="text" formControlName="incident_location" matInput />
          </mat-form-field>

          <mat-form-field appearance="outline">
                <mat-label>Incident Date</mat-label>
                <input formControlName="incident_date" matInput
                    [matDatepicker]="pickerStart">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix
                    [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Claim Amount</mat-label>
            <input type="text" formControlName="claim_amount" matInput />
          </mat-form-field>

          <div style="width: 100%;">
                <div>
                    <label class="upload">
                    <input type="file" (change)="onFileChange($event)"/>
                    Upload Report
                    <p style="color: blue;">{{fileName}}</p>
                    </label>
              </div>
          </div>

          <div style="width: 100%;">
            <div>
                <label class="upload">
                  <input type="file" (change)="onFileChange2($event)"/>
                  Upload Proof of Claim
                  <p style="color: blue;">{{fileName2}}</p>
                </label>
              </div>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Incident Description</mat-label>
            <textarea
              formControlName="incident_description"
              matInput
              placeholder="Enter Description"
            ></textarea>
          </mat-form-field>

          <div class="submit">
              <button mat-raised-button style="font-weight: bold;" color="accent" (click)="submit()">Submit Claim </button>
          </div>

        </form>
      </div>
    </div>
</section>
